export const DATA_ACCESS = process.env.https://da.poc.dip.dev.as8677.net/data_access
export const DIP_GCP = process.env.dev.gw-dip.worldline-solutions.com
